import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Treats typed dates as day/month/year (dd/MM/yyyy or dd-MM-yyyy).
 * Default NativeDateAdapter uses Date.parse(), which interprets slash-separated
 * dates as US mm/dd and causes dd/mm input to swap.
 */
@Injectable()
export class DdMmYyyyNativeDateAdapter extends NativeDateAdapter {
  private static readonly DM_Y = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/;

  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        return null;
      }
      const parts = DdMmYyyyNativeDateAdapter.DM_Y.exec(trimmed);
      if (parts) {
        const day = Number(parts[1]);
        const month = Number(parts[2]) - 1;
        const year = Number(parts[3]);
        const date = new Date();
        date.setFullYear(year, month, day);
        date.setHours(0, 0, 0, 0);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month ||
          date.getDate() !== day
        ) {
          return this.invalid();
        }
        return date;
      }
    }
    return super.parse(value as never, parseFormat as never);
  }
}
